export default "__VITE_ASSET__BRaoyWNE__"